import { useEffect } from 'react';
import { IMatrixCreationParameters } from './matrix-creation-interfaces';
import { useMatrixCreationStore } from './data/matrix-creation-store';
import MatrixCreationParameters from './ui/parameters';
import MatrixCreationView from './ui/view';

const initialParameters: IMatrixCreationParameters = {
    values: [
        ["בינוני", "תקין",       "לא", "תקין", "דיאטה"],
        ["נמוך",    "גבוה",      "לא", "תקין", "ללא טיפטל"],
        ["גבוה",    "תקין",      "לא", "תקין", "תרופתי"],
        ["נמוך",    "גבוה מאוד", "כן", "תקין", "ללא טיפטל"],
        ["בינוני",   "תקין",     "כן", "לא תקין", "תרופתי"],
        ["גבוה",     "תקין",     "לא", "תקין", "תרופתי"],
        ["בינוני",  "גבוה מאוד", "לא", "תקין", "דיאטה"],
        ["נמוך",      "תקין",    "כן", "תקין", "דיאטה"],
        ["נמוך",      "גבוה",    "כן", "תקין", "ללא טיפטל"],
    ],
    rowNames: [
        "סוכר",
        "לחץ דם",
        "מעשן",
        "BMI",
        "אופן טיפול"
    ]
};

const MatrixCreationHome = () => {

    const params = useMatrixCreationStore(store => store.params);
    const setParams = useMatrixCreationStore(store => store.setParams);

    useEffect(() => {
        setParams(initialParameters);
    }, [setParams]);

    return(
        <div className="w-full py-2 overflow-auto">

            <div className="w-full mb-4">
                <h1 className="text-2xl px-2 mb-4">Matrix Creation</h1>

                {
                    params &&
                    <div className="flex gap-4 ml-2">
                        <MatrixCreationParameters />
                        <MatrixCreationView />
                    </div>
                }
            </div>

        </div>
    )
};

export default MatrixCreationHome;
